// import { Button } from 'libs/ui';
import { Content } from './line-numbers.styled';

export const LineNumbers = (props) => {
  const { rows } = props;

  const itemsEl = [];
  for (let index = 0; index < rows; index++) {
    itemsEl.push(<div key={index}>{index + 1}</div>);
  }
  return <Content>{itemsEl}</Content>;
};
